<template>
  <!-- 主要内容 -->
  <div class="content-main">
    <!-- <div class="box-title">
      <p>名称</p>
      <p>作者</p>
      <p>日期</p>
      <p>操作</p>
    </div> -->
    <div v-if="mydata.userFavoritesArr.length === 0">
      <p
        style="
          line-height: 300px;
          text-align: center;
          letter-spacing: 1px;
          color: #999999;
        "
      >
        暂无收藏
      </p>
    </div>
    <div class="box-big" v-else>
      <div
        class="box-item"
        v-for="(item, index) in mydata.userFavoritesArr"
        :key="index"
      >
        <p style="cursor: pointer" @click="submitButton(item.content)">
          {{ item.content.title }}
        </p>
        <div>
          <p>
            <span v-if="item.content.author" style="margin-right: 30px;">作者：{{ item.content.author }}</span>

            <span>
              日期：
              {{
                dayjs(item.content.release_time * 1000).format("YYYY-MM-DD")
              }}</span
            >
          </p>

          <p @click="cancelCollect(item)" style="cursor: pointer">取消收藏</p>
        </div>
      </div>
    </div>
    <!--分页 -->
    <div
      class="gl-pagination"
      
    >
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { DocumentRemove, Delete } from "@element-plus/icons-vue";

import { IconPark } from "@icon-park/vue-next/es/all";
import { useRouter, useRoute } from "vue-router";
import { reactive } from "vue";

import dayjs from "dayjs";
import { useIdGetUrl } from "@/utils/slide.js";

//引入我的收藏列表、取消收藏接口
import {
  userFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";

import { ElMessage, ElMessageBox } from "element-plus";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  userFavoritesArr: [], //收藏列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  type: "3", //写死-类型就是3
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userFavoritesFn();
}

//获取收藏列表
function userFavoritesFn() {
  userFavoritesList(mydata.userInfo.jwt, {
    type: mydata.type,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    mydata.userFavoritesArr = res.data.list;
    mydata.pageObj.total = res.data.count;
  });
}

userFavoritesFn();

//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          userFavoritesFn();
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}

//按钮点击事件
function submitButton(content) {
  // console.log(content.column_id);
  // 路由赋值
  let path = "";
  if (content.column_id === 26) {
    path = "/layout/list/KnowledgeDetails";
  } else if (content.column_id === 24) {
    path = "/layout/list/researchDetails";
  }
  // 路由跳转
  router.push({
    path: path,
    query: { id: content.id },
  });
}
</script>

<style scoped lang="scss">
//主要内容
.content-main {
  // width: 916px;
  //height: 567px;
  // border: 1px solid red;
  // padding-bottom:40px;
  // margin-top: 30px;
  padding:0px 16px;
 
  //装每一条的大盒子
  .box-big {
    min-height: 500px;
    // border:1px solid blue;
    //每一条
    .box-item {
      height: 100px;
      padding:16px 0px 10px 0px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      // padding: 0px 43px 0px 19px;
      // margin-bottom: 20px;
      // position: relative;
      border-bottom: 1px solid #dcdee2;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      > p {
        // width: 300px;
        // border:1px solid rgb(0, 255, 85);
        line-height: 22px;

        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
      > div {
        display: flex;
        // flex-direction: column;
        justify-content: space-between;
        > p {
          // width: 180px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          // > span {
          //   margin-right: 20px;
          // }
          // border:1px solid red;
        }
      }
    }
    .box-item:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    .box-item:hover {
      p {
        color: #009de0;
      }
    }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
// .content-main {
//   width: 916px;
//   //height: 567px;
//   // border:1px solid red;
//   // margin-top: 30px;
//   .box-title {
//     width: 916px;
//     height: 47px;
//     padding: 0px 43px 0px 19px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     font-size: 16px;
//     font-weight: 400;
//     color: #333333;
//     background-color: #f7f9fa;
//     //  border:1px solid blue;
//     > p:nth-of-type(2) {
//       width: 64px;
//       // border: 1px solid red;
//     }
//   }
//   .box-item {
//     height: 65px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 0px 43px 0px 19px;
//     // margin-bottom: 20px;
//     // position: relative;
//     border-bottom: 1px solid #dcdee2;
//     font-size: 16px;
//     font-weight: 400;
//     color: #333333;
//     > p:nth-of-type(1) {
//       width: 345px;
//       // border:1px solid rgb(0, 255, 85);
//       line-height: 24px;
//       display: -webkit-box;
//       -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
//       text-overflow: ellipsis; //文本溢出 用省略号显示
//       -webkit-line-clamp: 2; //几行
//       overflow: hidden;
//     }
//     > p:nth-of-type(2) {
//       width: 64px;
//     }
//   }
//   .box-item:nth-last-of-type(1) {
//     margin-bottom: 0px;
//   }
//   // .box-item::before {
//   //   content: "";
//   //   position: absolute;
//   //   display: block;
//   //   top: 9px;
//   //   left: 0px;
//   //   width: 7px;
//   //   height: 7px;
//   //   background-color: #dcdee2;
//   //   border-radius: 3.5px;
//   // }

//   .box-item:hover {
//     p {
//       color: #009de0;
//     }
//   }
//   // .box-item:hover::before {
//   //   content: "";
//   //   position: absolute;
//   //   display: block;
//   //   top: 9px;
//   //   left: 0px;
//   //   width: 7px;
//   //   height: 7px;
//   //   border-radius: 3.5px;
//   //   background-color: #009de0 !important;
//   // }

//   //////////分页
//   .paging {
//     // margin: 0 auto;
//     display: flex;
//     justify-content: center;
//     margin-top: 40px;
//     margin-bottom: 40px;
//     :deep(.el-button.is-plain) {
//       margin-left: 24px;
//     }
//   }
//   //最左边的箭头
//   :deep(.btn-prev.is-first) {
//     margin-right: 12px;
//     background-color: #f5f6f7;
//   }
//   :deep(.btn-next) {
//     background-color: #f5f6f7;
//   }
//   //每个页
//   :deep(.number) {
//     margin-right: 12px;
//     // color:#BBBDBF;
//     background-color: #f5f6f7;
//   }
//   //省略号
//   :deep(.more.btn-quicknext.el-icon) {
//     margin-right: 12px;
//     background-color: #f9f9f9;
//   }

//   .demo-pagination-block + .demo-pagination-block {
//     margin-top: 10px;
//   }
//   .demo-pagination-block .demonstration {
//     margin-bottom: 16px;
//   }
// }
</style>